import { roles } from '@/enums'
import { useCurrentRoleStore } from '~/stores/currentRole'

export default defineNuxtRouteMiddleware(async (to, _from) => {
  const user = useSupabaseUser()
  if (!user.value) return navigateTo('/login')
  const schoolId = useCurrentRoleStore().getCurrentRole().schoolId
  const memberships = await useSchoolMemberships().load()
  const matchingMemberships = memberships.filter(
    (membership) => membership.schoolId === schoolId,
  )
  const isGuardian = matchingMemberships.some(
    (membership) => membership.role === roles.GUARDIAN,
  )
  const isStaffPreview = to.query.preview === 'staff'
  const isStaff = matchingMemberships.some(
    (membership) =>
      membership.role === roles.ADMIN || membership.role === roles.TEACHER,
  )
  if ((!isStaffPreview && !isGuardian) || (isStaffPreview && !isStaff)) {
    return navigateTo('/')
  }
})
